var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-item",
    { staticClass: "connector-item mb-2" },
    [
      _c(
        "v-list-item-content",
        [
          _c(
            "v-list-item-title",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-chip",
                {
                  staticClass: "mr-2",
                  attrs: { color: "secondary", "x-small": "" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.row.connectorLabel || _vm.row.type) + " "
                  ),
                ]
              ),
              _c(
                "v-chip",
                {
                  staticClass: "mr-2",
                  attrs: {
                    color: _vm.row.enabled ? "primary" : "error",
                    "x-small": "",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.row.enabled ? _vm.$t("enabled") : _vm.$t("disabled")
                      ) +
                      " "
                  ),
                ]
              ),
              _vm.row.organizationName
                ? _c("span", { staticClass: "font-weight-medium" }, [
                    _vm._v(" " + _vm._s(_vm.row.organizationName) + " "),
                  ])
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "", left: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { icon: "", "x-small": "" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-dots-vertical"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("update")
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "v-icon",
                                { attrs: { small: "", color: "primary" } },
                                [_vm._v("mdi-pencil")]
                              ),
                            ],
                            1
                          ),
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(_vm.$t("connector.update-title"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("toggle-enabled")
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    small: "",
                                    color: _vm.row.enabled
                                      ? "error"
                                      : "success",
                                  },
                                },
                                [_vm._v("mdi-power")]
                              ),
                            ],
                            1
                          ),
                          _c("v-list-item-title", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.row.enabled
                                    ? _vm.$t("connector.disable-title")
                                    : _vm.$t("connector.enable-title")
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("delete")
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "v-icon",
                                { attrs: { small: "", color: "error" } },
                                [_vm._v("mdi-delete")]
                              ),
                            ],
                            1
                          ),
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(_vm.$t("connector.delete-title"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-list-item-subtitle", { staticClass: "mt-1" }, [
            _c("div", { staticClass: "d-flex flex-column" }, [
              _c(
                "span",
                { staticClass: "text-caption grey--text" },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("connector.crm-id")) + ":"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.row.crmId) + " "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1 copy-icon",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.emitCopy(_vm.row.crmId)
                        },
                      },
                    },
                    [_vm._v("mdi-content-copy")]
                  ),
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "text-caption grey--text" },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("organization-id")) + ":"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.row.organizationId) + " "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1 copy-icon",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.emitCopy(_vm.row.organizationId)
                        },
                      },
                    },
                    [_vm._v("mdi-content-copy")]
                  ),
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "text-caption grey--text" },
                [
                  _c("strong", [_vm._v("ID:")]),
                  _vm._v(" " + _vm._s(_vm.row.id) + " "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1 copy-icon",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.emitCopy(_vm.row.id)
                        },
                      },
                    },
                    [_vm._v("mdi-content-copy")]
                  ),
                ],
                1
              ),
              _vm.row.username
                ? _c(
                    "span",
                    {
                      staticClass:
                        "text-caption grey--text d-flex align-center",
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("connector.username")) + ":"),
                      ]),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.showUsername ? _vm.row.username : "••••••")
                        ),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-1",
                          attrs: { icon: "", "x-small": "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.showUsername = !_vm.showUsername
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.showUsername ? "mdi-eye-off" : "mdi-eye"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.showUsername
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "ml-1 copy-icon",
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.emitCopy(_vm.row.username)
                                },
                              },
                            },
                            [_vm._v("mdi-content-copy")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.row.password
                ? _c(
                    "span",
                    {
                      staticClass:
                        "text-caption grey--text d-flex align-center",
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("connector.password")) + ":"),
                      ]),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.showPassword ? _vm.row.password : "••••••")
                        ),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-1",
                          attrs: { icon: "", "x-small": "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.showPassword = !_vm.showPassword
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.showPassword ? "mdi-eye-off" : "mdi-eye"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.showPassword
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "ml-1 copy-icon",
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.emitCopy(_vm.row.password)
                                },
                              },
                            },
                            [_vm._v("mdi-content-copy")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "span",
                { staticClass: "text-caption grey--text d-flex align-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-1",
                      attrs: { icon: "", "x-small": "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("toggle-sessions")
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.expandedSessions
                              ? "mdi-chevron-down"
                              : "mdi-chevron-right"
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("strong", [_vm._v(_vm._s(_vm.$t("connector.sessions")))]),
                  _vm.sessionsLoading
                    ? _c("v-progress-circular", {
                        staticClass: "ml-2",
                        attrs: { indeterminate: "", size: "12", width: "2" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.expandedSessions
                ? _c(
                    "div",
                    { staticClass: "ml-4 mt-1" },
                    [
                      !_vm.sessionsLoading && _vm.sessions.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-caption grey--text" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("connector.sessions-empty")) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._l(_vm.sessions, function (s) {
                        return _c(
                          "div",
                          {
                            key: s.id,
                            staticClass: "session-item text-caption grey--text",
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("strong", [_vm._v("ID:")]),
                                _vm._v(" " + _vm._s(s.id) + " "),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1 copy-icon",
                                    attrs: { small: "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.emitCopy(s.id)
                                      },
                                    },
                                  },
                                  [_vm._v("mdi-content-copy")]
                                ),
                              ],
                              1
                            ),
                            s.userId
                              ? _c("div", [
                                  _c("strong", [_vm._v("userId:")]),
                                  _vm._v(" " + _vm._s(s.userId) + " "),
                                ])
                              : _vm._e(),
                            s.userGroupId
                              ? _c("div", [
                                  _c("strong", [_vm._v("userGroupId:")]),
                                  _vm._v(" " + _vm._s(s.userGroupId) + " "),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              [
                                _c("strong", [_vm._v("expiresAt:")]),
                                _vm._v(" " + _vm._s(s.expiresAt || "-") + " "),
                                _vm.isExpired(s)
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          color: "error",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("expired")) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }